import { confirmToast } from "../../utils/toast";
import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";

const PackingMaster = () => {
  const [packing, setPacking] = useState([]);
  const [name, setName] = useState("");
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    loadPacking();
  }, []);

  const loadPacking = async () => {
    const res = await axios.get("/packing");
    setPacking(res.data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editingId) {
        await axios.put(`/packing/${editingId}`, { PackingName: name });
      } else {
        await axios.post("/packing", { PackingName: name });
      }

      alert(editingId ? "Packing updated successfully" : "Packing saved successfully");
      setName("");
      setEditingId(null);
      loadPacking();
    } catch (err) {
      alert(err.response?.data?.message || "Error saving packing");
    }
  };

  const handleEdit = (p) => {
    setName(p.PackingName);
    setEditingId(p.PackingID);
  };

  const handleDelete = async (p) => {
    if (!await confirmToast(`Delete packing "${p.PackingName}"?`)) return;

    try {
      await axios.delete(`/packing/${p.PackingID}`);
      if (editingId === p.PackingID) {
        setName("");
        setEditingId(null);
      }
      await loadPacking();
    } catch (err) {
      alert(err.response?.data?.message || err.response?.data || "Unable to delete packing");
    }
  };

  return (
    <div className="container-fluid">
      <h4 className="fw-bold mb-3">Packing Master</h4>

      <div className="card shadow-sm border-0">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label fw-semibold">Packing Name *</label>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="form-control"
                  placeholder="Enter Packing Name"
                  required
                />
              </div>
            </div>

            <div className="mt-4 text-end">
              <button className="btn btn-success">
                {editingId ? "Update" : "Save"}
              </button>
            </div>
          </form>

          <hr className="my-4" />

          <div className="table-responsive">
            <table className="table table-bordered table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Packing Name</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {packing.map(p => (
                  <tr key={p.PackingID}>
                    <td>{p.PackingID}</td>
                    <td>{p.PackingName}</td>
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={() => handleEdit(p)}
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(p)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackingMaster;
